import {
  DataTextureTypedArray,
  Texture,
  bufferToDataType,
} from "../../objects/textures/texture";

export class Texture2D extends Texture {
  private readonly width_: number;
  private readonly height_: number;

  constructor(data: DataTextureTypedArray, width: number, height: number) {
    super();
    this.dataFormat = "scalar";
    this.dataType = bufferToDataType(data);

    this.data_ = data;
    this.width_ = width;
    this.height_ = height;
  }

  public get type() {
    return "Texture2D";
  }

  public get width() {
    return this.width_;
  }

  public get height() {
    return this.height_;
  }
}
